export const DEFAULT_TOOLTIP_TRIGGER_LENGTH = 28;
export const SELECT_TOOLTIP_MAX_CONTENT_LENGTH = 160;
export const SEARCHABLE_TOOLTIP_MAX_CONTENT_LENGTH = 200;
export const SEARCHABLE_OPTION_DISPLAY_MAX_LENGTH = 90;
export const SEARCHABLE_TAG_DISPLAY_MAX_LENGTH = 70;
